export const BENEFITS_PATH = '/benefits';
export const CAREERS_PATH = '/careers';
export const CAREERS_TEAMS_PATH = '/careers/teams';
export const DIVERSITY_INCLUSION_PATH = '/diversity-inclusion';
